var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraPanDesktopImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 300,
    viewBox: "0 0 223 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.4263 74.268L109.016 65.6055L120.421 67.4802L124.921 78.1859V110.077L113.458 117.796L105.274 114.99L99.4263 102.588V74.268Z",
    fill: "url(#paint0_linear_282_3537)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 36C67.8368 36.0474 32.0474 71.8559 32 116.043V208.723C32 252.931 67.8158 288.766 112 288.766C156.184 288.766 192 252.931 192 208.723V116.043C191.953 71.8559 156.163 36.0474 112 36ZM120.421 78.1277V103.404C120.421 108.059 116.653 111.83 112 111.83C107.347 111.83 103.579 108.059 103.579 103.404V78.1277C103.579 73.4726 107.347 69.7022 112 69.7022C116.653 69.7022 120.421 73.4726 120.421 78.1277ZM40.4211 116.043C40.4842 78.1646 70 46.8848 107.789 44.6414V61.8769C100.374 63.7938 95.1842 70.471 95.1579 78.1277V103.404C95.1842 111.066 100.374 117.743 107.789 119.655V137.106H40.4211V116.043ZM183.579 208.723C183.537 248.26 151.516 280.298 112 280.34C72.4842 280.298 40.4632 248.26 40.4211 208.723V145.532H183.579V208.723ZM183.579 137.106H116.211V119.655C123.626 117.738 128.816 111.061 128.842 103.404V78.1277C128.816 70.4657 123.626 63.7885 116.211 61.8769V44.6414C154 46.8848 183.516 78.1698 183.579 116.043V137.106Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_3537",
    x1: 124.921,
    y1: 65.6055,
    x2: 122.764,
    y2: 118.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#687D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE3E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPanDesktopImg);
export default __webpack_public_path__ + "static/media/camera-pan-desktop_img.03688a8ac3d2e2505e721a37d9fbee4e.svg";
export { ForwardRef as ReactComponent };